module.exports = __webpack_public_path__ + "img/cluster-setting.a9a8e4fe.svg";